import { Component } from "react";

/**
 * React Error Boundary — catches render-phase errors in the subtree.
 * Prevents a single broken component from crashing the entire app.
 *
 * Usage:
 *   <ErrorBoundary fallback={<p>Something went wrong.</p>}>
 *     <MyComponent />
 *   </ErrorBoundary>
 *
 * @extends {Component<{children: React.ReactNode, fallback?: React.ReactNode}>}
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(_error, _info) {}

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <main style={{ padding: "10rem 5rem", textAlign: "center" }}>
          <h2 style={{ color: "var(--gold)", marginBottom: "1rem" }}>
            Something went wrong.
          </h2>
          <button
            onClick={() => this.setState({ hasError: false })}
            style={{ color: "var(--gold)", background: "none", border: "none", cursor: "pointer", fontSize: "12px", letterSpacing: ".1em", textTransform: "uppercase" }}
          >
            Try again →
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
